import { render, staticRenderFns } from "./RegistrationCompleteStep.vue?vue&type=template&id=b816b27a&"
import script from "./RegistrationCompleteStep.vue?vue&type=script&lang=ts&"
export * from "./RegistrationCompleteStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports